import { useEffect, useState } from 'react';
import { uploadFile } from '../../Services/resources';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export const useAssignResourcesPage = () => {
	const navigate = useNavigate();
	const [form, setForm] = useState({
		institutionCode: '',
		csvFile: null,
	});
	const [errors, setErrors] = useState({
		institutionCode: false,
		csvFile: false,
	});
	const [assignedResources, setAssignedResources] = useState([]);
	const [notFoundResources, setNotFoundResources] = useState([]);
	const [apiMessage, setApiMessage] = useState('');

	const handleResetForm = () => {
		setForm({
			institutionCode: '',
			csvFile: null,
		});
		setErrors({
			institutionCode: false,
			csvFile: false,
		});
	};
	const handleSubmit = async (e) => {
		e.preventDefault();

		// Validaciones
		const newErrors = {
			institutionCode: !form.institutionCode?.trim(),
			csvFile: !form.csvFile || form.csvFile.type !== 'text/csv',
		};

		setErrors(newErrors);

		if (newErrors.institutionCode || newErrors.csvFile) {
			return;
		}

		const idLoading = toast.loading('Assigning resources...', {
			closeButton: true,
			autoClose: 1000,
		});

		try {
			const response = await uploadFile(form.csvFile, form.institutionCode);
			toast.update(idLoading, {
				render: 'Resources assigned.',
				type: 'success',
				isLoading: false,
				closeButton: true,
				autoClose: 1000,
			});
			setAssignedResources(response.matches);
			setNotFoundResources(response.no_matches);
			setApiMessage(response.message);

			handleResetForm();
		} catch (error) {
			console.error(error);
			setApiMessage('');
			toast.update(idLoading, {
				render: 'Error, try again.',
				type: 'error',
				isLoading: false,
				closeButton: true,
				autoClose: 1000,
			});
		}
	};

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file && file.type === 'text/csv') {
			setForm({ ...form, csvFile: file });
		} else {
			alert('Please upload a valid CSV file exported from ZOTERO.');
		}
	};

	useEffect(() => {
		if (!localStorage.name || !localStorage.email) {
			navigate('/');
		}
	}, [navigate]);

	return {
		setForm,
		form,
		handleFileChange,
		handleSubmit,
		errors,
		assignedResources,
		notFoundResources,
		apiMessage,
	};
};
